
export const enCommon = {
  // Navigation
  'nav.home': 'Home',
  'nav.about': 'About Us',
  'nav.services': 'Services',
  'nav.products': 'Products',
  'nav.projects': 'Projects',
  'nav.partners': 'Partners',
  'nav.news': 'News',
  'nav.contact': 'Contact Us',
  
  // Common buttons
  'btn.readMore': 'Read More',
  'btn.contact': 'Contact Us',
  'btn.consultation': 'Free Consultation',
  'btn.viewProjects': 'View Projects',
  'btn.learnMore': 'Learn More',
  'btn.callUs': 'Call Us',
  'btn.requestConsultation': 'Request Consultation',
  'btn.viewDetails': 'View Details',
  'btn.buy': 'Buy',
  'btn.subscribe': 'Subscribe',
  'btn.viewAll': 'View All',
  'btn.getQuote': 'Get Quote',
  'btn.viewCatalog': 'View Complete Catalog',
  'btn.contactExperts': 'Contact Experts',
  
  // Common phrases
  'common.years': 'Years',
  'common.experience': 'Experience',
  'common.projects': 'Projects',
  'common.customers': 'Customers',
  'common.readTime': 'min read',
  'common.location': 'Location',
  'common.area': 'Area',
  'common.established': 'Established',
  'common.employees': 'Employees',
  'common.specialization': 'Specialization',
  'common.category': 'Category',
  'common.tags': 'Tags',
  'common.date': 'Date',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.all': 'All',
  'common.new': 'New',
  'common.found': 'found',
  'common.searchPlaceholder': 'Search products...',
  
  // Company info
  'company.name': 'Iran GH',
  'company.tagline': 'Smart Greenhouses',
  'company.description': 'Designer, builder and equipment supplier of smart glass greenhouses in Iran',
  'company.phone': '021-88441386',
  'company.email': 'IranGH.Co@Gmail.com',
  'company.address': 'Tehran, Motahari St., Yousefian St., Shokooh Alley, No. 6',
  'company.warehouse1': 'Jajrood Warehouse',
  'company.warehouse2': 'Shoosh Tehran Warehouse',
  'company.salesManager': '0912-909-5302',
  
  // Footer
  'footer.quickLinks': 'Quick Links',
  'footer.services': 'Our Services',
  'footer.contactInfo': 'Contact Info',
  'footer.copyright': '© 2024 Iran GH. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Use',
  'footer.madeWith': 'Made with Readdy',
  
  // Projects page
  'projects.title': 'Our Projects',
  'projects.subtitle': 'Successful greenhouse projects across Iran and the region',
  'projects.featured': 'Featured Projects',
  'projects.all': 'All Projects',
  'projects.commercial': 'Commercial',
  'projects.research': 'Research',
  'projects.hydroponic': 'Hydroponic',
  'projects.traditional': 'Traditional',
  'projects.sqm': 'sqm',
  'projects.completed': 'Completed',
  'projects.ongoing': 'Ongoing',
  'projects.planning': 'Planning',
  'projects.planning': 'Planning',
  
  // About page
  'about.title': 'About Iran GH',
  'about.subtitle': 'Leading provider of smart greenhouse solutions in Iran',
  'about.story': 'Our Story',
  'about.mission': 'Our Mission',
  'about.vision': 'Our Vision',
  'about.values': 'Our Values',
  'about.team': 'Our Team',
  'about.achievements': 'Achievements',
  'about.storyText1': 'Founded in 2009, Iran GH has been at the forefront of greenhouse technology in Iran and the Middle East region. What started as a small engineering firm has grown into the leading provider of smart greenhouse solutions.',
  'about.storyText2': 'Our journey began with a simple mission: to revolutionize agriculture through innovative greenhouse technologies. Over the years, we have successfully completed over 200 projects, ranging from small family farms to large commercial operations.',
  'about.storyText3': 'Today, we continue to push the boundaries of what\'s possible in controlled environment agriculture, helping farmers achieve higher yields while using fewer resources.',
  'about.missionText': 'Our mission is to provide sustainable and innovative solutions to increase agricultural productivity while preserving natural resources.',
  'about.visionText': 'Our vision is to become the regional leader in smart greenhouse technology and contribute to food security.',
  'about.valuesText': 'Our values include innovation, quality, sustainability, and commitment to customer satisfaction.',
  
  // Services page
  'services.title': 'Our Services',
  'services.subtitle': 'Comprehensive greenhouse solutions from design to maintenance',
  'services.design': 'Design & Engineering',
  'services.construction': 'Construction',
  'services.equipment': 'Equipment Supply',
  'services.maintenance': 'Maintenance',
  'services.consultation': 'Consultation',
  'services.automation': 'Automation Systems',
  'services.mainTitle': 'Iran GH Services',
  'services.heroSubtitle': 'Everything for your smart greenhouse from design to operation',
  'services.mainServices': 'Our Main Services',
  'services.mainServicesSubtitle': 'Iran GH combines domestic experience with international technology to provide the most complete greenhouse services',
  'services.smartDesign': 'Smart Greenhouse Design',
  'services.smartDesignDesc': 'Complete design of glass greenhouses considering climatic conditions, crop type and specific needs of each project',
  'services.constructionInstall': 'Construction & Installation',
  'services.constructionInstallDesc': 'Construction and installation of glass greenhouses using the best materials and advanced equipment',
  'services.equipmentAutomation': 'Equipment & Automation',
  'services.equipmentAutomationDesc': 'Equipping greenhouses with the most modern control and automation systems',
  'services.additionalServices': 'Additional Services',
  'services.additionalServicesSubtitle': 'In addition to main services, we offer a wide range of complementary services',
  'services.expertConsultation': 'Expert Consultation',
  'services.expertConsultationDesc': 'Providing technical and specialized consultation in all project phases',
  'services.maintenanceRepair': 'Maintenance & Repairs',
  'services.maintenanceRepairDesc': 'After-sales services and periodic maintenance of greenhouses',
  'services.userTraining': 'User Training',
  'services.userTrainingDesc': 'Complete training on operation and maintenance methods',
  'services.performanceOptimization': 'Performance Optimization',
  'services.performanceOptimizationDesc': 'Analysis and improvement of existing greenhouse performance',
  'services.qualityAssurance': 'Quality Assurance',
  'services.qualityAssuranceDesc': 'Providing complete warranty and guarantee on all services',
  'services.support247': '24/7 Support',
  'services.support247Desc': 'Support and guidance at all hours of the day and night',
  'services.workProcess': 'Our Work Process',
  'services.workProcessSubtitle': 'Complete project execution steps from start to finish',
  'services.initialConsultation': 'Initial Consultation',
  'services.initialConsultationDesc': 'Needs assessment and project feasibility study',
  'services.designEstimate': 'Design & Estimate',
  'services.designEstimateDesc': 'Providing complete design and cost estimation',
  'services.contractSigning': 'Contract Signing',
  'services.contractSigningDesc': 'Contract signing and scheduling',
  'services.projectExecution': 'Project Execution',
  'services.projectExecutionDesc': 'Starting construction and installation with complete supervision',
  'services.testDelivery': 'Testing & Delivery',
  'services.testDeliveryDesc': 'System testing and final delivery',
  'services.support': 'Support',
  'services.supportDesc': 'Providing after-sales services and training',
  'services.advancedTechnologies': 'Advanced Technologies',
  'services.advancedTechnologiesSubtitle': 'Using the latest and most modern technologies in the world',
  'services.smartClimateControl': 'Smart Climate Control',
  'services.smartClimateControlDesc': 'Advanced systems for temperature, humidity and ventilation control',
  'services.smartIrrigation': 'Smart Irrigation',
  'services.smartIrrigationDesc': 'Drip irrigation system with automatic control',
  'services.remoteMonitoring': 'Remote Monitoring',
  'services.remoteMonitoringDesc': 'Greenhouse monitoring and control via mobile and computer',
  'services.advancedHydroponics': 'Advanced Hydroponics',
  'services.advancedHydroponicsDesc': 'Soilless cultivation systems with precise nutrition',
  'services.qualityAssuranceTitle': 'Quality Assurance',
  'services.qualityAssuranceSubtitle': 'Our service quality is guaranteed by valid licenses and certificates',
  'services.dutchTechnology': 'Dutch Technology',
  'services.dutchTechnologyDesc': 'Cooperation with Vander Hoeven',
  'services.europeanStandard': 'European Standard',
  'services.europeanStandardDesc': 'CE and ISO certification',
  'services.iranianQuality': 'Iranian Quality',
  'services.iranianQualityDesc': 'Approved by Ministry of Agriculture',
  'services.completeWarranty': 'Complete Warranty',
  'services.completeWarrantyDesc': '5-year warranty',
  'services.servicePackages': 'Service Packages',
  'services.servicePackagesSubtitle': 'Different service packages suitable for your needs',
  'services.basicPackage': 'Basic Package',
  'services.basicPackageDesc': 'Suitable for small greenhouses',
  'services.professionalPackage': 'Professional Package',
  'services.professionalPackageDesc': 'Suitable for medium greenhouses',
  'services.advancedPackage': 'Advanced Package',
  'services.advancedPackageDesc': 'Suitable for large greenhouses',
  'services.mostPopular': 'Most Popular',
  'services.selectPackage': 'Select Package',
  'services.contactForPrice': 'Contact for Price',
  'services.faq': 'Frequently Asked Questions',
  'services.faqSubtitle': 'Answers to common questions about Iran GH services',
  'services.readyToStart': 'Ready to Start Your Project?',
  'services.readyToStartSubtitle': 'Contact our experts now and get free consultation',
  
  // Service features
  'services.features.structuralDesign': 'Resistant and standard structural design',
  'services.features.loadCalculation': 'Wind and earthquake load calculations',
  'services.features.ventilationDesign': 'Ventilation and temperature control system design',
  'services.features.orientationSelection': 'Selecting the best greenhouse orientation',
  'services.features.smartIrrigationDesign': 'Smart irrigation system design',
  'services.features.qualityMaterials': 'Using quality aluminum and glass',
  'services.features.expertInstallation': 'Installation by expert team',
  'services.features.qualityControl': 'Quality control in all stages',
  'services.features.systemTesting': 'System testing and commissioning',
  'services.features.completeWarranty': 'Providing complete warranty',
  'services.features.smartClimateSystem': 'Smart climate control system',
  'services.features.automaticIrrigation': 'Automatic drip irrigation',
  'services.features.remoteMonitoringSystem': 'Remote monitoring system',
  'services.features.lightShadeControl': 'Light and shade control',
  'services.features.hydroponicFeeding': 'Hydroponic feeding system',
  
  // Package features
  'services.package.simpleDesign': 'Simple greenhouse design',
  'services.package.constructionInstall': 'Construction and installation',
  'services.package.dripIrrigation': 'Drip irrigation',
  'services.package.twoYearWarranty': '2-year warranty',
  'services.package.advancedDesign': 'Advanced design',
  'services.package.climateControl': 'Climate control system',
  'services.package.smartIrrigation': 'Smart irrigation',
  'services.package.threeYearWarranty': '3-year warranty',
  'services.package.completeSmartDesign': 'Complete smart design',
  'services.package.fullAutomation': 'Complete automation',
  'services.package.remoteMonitoring': 'Remote monitoring',
  'services.package.fiveYearWarranty': '5-year warranty',
  
  // FAQ questions
  'services.faq.q1': 'How long does a greenhouse project take?',
  'services.faq.a1': 'The execution time varies depending on the size and complexity of the project. Usually small greenhouses take 2-3 months and large greenhouses take 4-6 months.',
  'services.faq.q2': 'What does your service warranty include?',
  'services.faq.a2': 'Our warranty includes greenhouse structure, installed equipment, control systems and technical services. We also provide 24/7 support.',
  'services.faq.q3': 'Is it possible to design custom greenhouses?',
  'services.faq.a3': 'Yes, we design all greenhouses based on customer needs and environmental conditions. No project is similar to another.',
  'services.faq.q4': 'What is the annual maintenance cost of a greenhouse?',
  'services.faq.a4': 'Maintenance cost varies depending on greenhouse size and equipment. We offer different maintenance programs that can be 5 to 15 percent of the initial cost.',
  'services.faq.q5': 'Do you provide greenhouse operation training?',
  'services.faq.a5': 'Yes, after greenhouse delivery, our team provides complete training in operation, maintenance and troubleshooting.',
  
  // Products page
  'products.title': 'Products & Equipment',
  'products.subtitle': 'Complete collection of modern greenhouse equipment and supplies',
  'products.structures': 'Greenhouse Structures',
  'products.climate': 'Climate Control',
  'products.irrigation': 'Irrigation Systems',
  'products.automation': 'Automation',
  'products.accessories': 'Accessories',
  'products.price': 'Price',
  'products.specifications': 'Specifications',
  'products.categories': 'Product Categories',
  'products.categoriesSubtitle': 'Learn about different types of equipment and their applications in modern greenhouses',
  'products.whyChoose': 'Why Choose Iran GH Products?',
  'products.whyChooseSubtitle': 'Benefits of choosing our products for your greenhouse',
  'products.techSupport': 'Specialized Technical Support',
  'products.techSupportDesc': 'Our expert team is ready to provide consultation and guidance in selecting the best products for your specific greenhouse needs.',
  'products.ctaTitle': 'Ready to Purchase Quality Products?',
  'products.ctaSubtitle': 'Contact us and take advantage of free consultation to select the best products',
  
  // Product categories
  'products.cat.all': 'All Products',
  'products.cat.substrates': 'Growing Media',
  'products.cat.support': 'Support Systems',
  'products.cat.protection': 'Protection & Control',
  'products.cat.heating': 'Heating Systems',
  'products.cat.tools': 'Tools & Equipment',
  'products.cat.smart': 'Smart Equipment',
  
  // Product stats
  'products.stats.diverseProducts': 'Diverse Products',
  'products.stats.trustedBrands': 'Trusted Brands',
  'products.stats.support247': 'Technical Support',
  'products.stats.qualityGuarantee': 'Quality Guarantee',
  
  // Product features
  'products.features.qualityGuaranteed': 'Quality Guaranteed',
  'products.features.qualityDesc': 'All products have international certificates and quality guarantee',
  'products.features.fastShipping': 'Fast Shipping',
  'products.features.fastShippingDesc': 'Shipping nationwide with proper packaging and timely delivery',
  'products.features.technicalSupport': 'Technical Support',
  'products.features.technicalSupportDesc': 'Free technical consultation and guidance for product selection and use',
  'products.features.fairPrice': 'Fair Price',
  'products.features.fairPriceDesc': 'Best prices with wholesale options and special discounts',
  
  // Support features
  'products.support.freeConsultation': 'Free consultation before purchase',
  'products.support.installationGuide': 'Installation and setup guidance',
  'products.support.afterSales': 'After-sales support',
  'products.support.training': 'Product usage training',
  
  // Partners page
  'partners.title': 'Our Partners',
  'partners.subtitle': 'Trusted partnerships for better solutions',
  'partners.international': 'International',
  'partners.local': 'Local',
  'partners.suppliers': 'Suppliers',
  'partners.distributors': 'Distributors',
  'partners.since': 'Partner since',
  'partners.website': 'Visit Website',
  'partners.heroTitle': 'Our Partners',
  'partners.heroSubtitle': 'Cooperation with the most reputable domestic and international companies to provide the best services',
  'partners.strategicPartnerships': 'Strategic Partnerships',
  'partners.strategicPartnershipsDesc': 'Iran GH, through close cooperation with reputable domestic and international companies, provides the best technologies and services to customers',
  'partners.globalTechnology': 'Access to Global Technology',
  'partners.globalTechnologyDesc': 'Benefiting from the latest world technologies in the greenhouse industry',
  'partners.qualityGuarantee': 'Quality Guarantee',
  'partners.qualityGuaranteeDesc': 'Using quality raw materials and components with international standards',
  'partners.technicalSupport': 'Technical Support',
  'partners.technicalSupportDesc': 'Receiving direct technical support from manufacturing companies',
  'partners.timelyDelivery': 'Timely Delivery',
  'partners.timelyDeliveryDesc': 'Project execution on schedule with optimal quality',
  'partners.mainPartners': 'Main Partners',
  'partners.mainPartnersDesc': 'Strategic cooperation with industry pioneers',
  'partners.allPartners': 'All Partners',
  'partners.domestic': 'Domestic',
  'partners.technicalPartners': 'Technical Partners',
  'partners.technicalPartnersDesc': 'Cooperation with greenhouse technology pioneers',
  'partners.supplierPartners': 'Supplier Partners',
  'partners.supplierPartnersDesc': 'Suppliers of quality raw materials and components',
  'partners.partnershipProcess': 'Partnership Process',
  'partners.partnershipProcessDesc': 'Iran GH cooperation stages with international and domestic partners',
  'partners.partnerSelection': 'Partner Selection',
  'partners.partnerSelectionDesc': 'Review and selection of reputable partners with appropriate experience and quality',
  'partners.negotiationContract': 'Negotiation & Contract',
  'partners.negotiationContractDesc': 'Conducting technical and commercial negotiations and signing cooperation agreements',
  'partners.technologyTransfer': 'Technology Transfer',
  'partners.technologyTransferDesc': 'Technical team training and knowledge and technology transfer',
  'partners.projectExecution': 'Project Execution',
  'partners.projectExecutionDesc': 'Starting practical cooperation and implementing joint projects',
  'partners.successStories': 'Success Stories',
  'partners.successStoriesDesc': 'Examples of successful projects resulting from strategic partnerships',
  'partners.isfahanGreenhouse': 'Isfahan Smart Greenhouse',
  'partners.isfahanGreenhouseDesc': 'Iran\'s first fully smart greenhouse with Dutch technology',
  'partners.mashadComplex': 'Mashhad Agricultural Complex',
  'partners.mashadComplexDesc': 'The largest greenhouse complex in Khorasan with European standards',
  'partners.ardabilResearch': 'Ardabil Research Greenhouse',
  'partners.ardabilResearchDesc': 'Agricultural research center with advanced equipment',
  'partners.domesticPartners': 'Domestic Partners',
  'partners.interestedInPartnership': 'Interested in Partnership?',
  'partners.interestedInPartnershipDesc': 'Iran GH is always looking to expand its partner network. Contact us and learn about partnership opportunities.',
  'partners.partnershipRequest': 'Partnership Request',
  'partners.contactUs': 'Contact Us',
  'partners.moreInfo': 'More Information',
  'partners.collaborationMethod': 'Collaboration Method:',
  'partners.servicesSpecialties': 'Services & Specialties:',
  
  // Partners page specific content
  'partners.netherlands': 'Netherlands',
  'partners.iran': 'Iran',
  'partners.israel': 'Israel',
  'partners.vanderHoevenSpecialization': 'Glass greenhouse design and construction',
  'partners.vanderHoevenDescription': 'Van der Hoeven is one of the pioneers in the greenhouse industry in the Netherlands with over 50 years of experience in designing, building and equipping glass greenhouses. This company has become one of the most reputable global brands in modern agriculture by providing advanced technologies and innovative solutions.',
  'partners.vanderHoevenService1': 'Glass greenhouse design',
  'partners.vanderHoevenService2': 'Climate control systems',
  'partners.vanderHoevenService3': 'Smart irrigation equipment',
  'partners.vanderHoevenService4': 'Sustainable energy systems',
  'partners.vanderHoevenService5': 'Technical consulting and design',
  'partners.vanderHoevenAchievement1': 'Over 1000 successful projects worldwide',
  'partners.vanderHoevenAchievement2': 'Pioneer in smart greenhouse technology',
  'partners.vanderHoevenAchievement3': 'Holder of international quality certificates',
  'partners.vanderHoevenAchievement4': 'Cooperation with the world\'s largest producers',
  'partners.vanderHoevenCollaboration': 'Iran GH as the only official representative of Van der Hoeven in Iran, is responsible for transferring advanced Dutch technologies to the Iranian market. This cooperation includes design, construction, installation and commissioning of glass greenhouses with European standards.',
  'partners.chehelsotoonSpecialization': 'Aluminum and PVC door and window production',
  'partners.chehelsotoonDescription': 'Chehelsotoon company with over 20 years of experience in the door and window industry, is one of the pioneers in aluminum and PVC product manufacturing in Iran. This company produces high-quality products with European standards by relying on world-class technology and skilled workforce.',
  'partners.chehelsotoonService1': 'Aluminum door and window production',
  'partners.chehelsotoonService2': 'Advanced PVC systems',
  'partners.chehelsotoonService3': 'Building facade and curtain wall',
  'partners.chehelsotoonService4': 'Safety and double-glazed glass',
  'partners.chehelsotoonService5': 'Design and execution of construction projects',
  'partners.chehelsotoonAchievement1': 'Over 500 successful projects nationwide',
  'partners.chehelsotoonAchievement2': 'Holder of national standard certificates',
  'partners.chehelsotoonAchievement3': 'Cooperation with the most reputable builders in the country',
  'partners.chehelsotoonAchievement4': 'Production of European quality products',
  'partners.chehelsotoonCollaboration': 'Strategic cooperation of Chehelsotoon with Iran GH in the production of aluminum and glass components for greenhouses ensures the quality and durability of final products. This partnership includes design and production of resistant structures, ventilation systems and automatic greenhouse doors.',
  'partners.privaSpecialization': 'Climate control systems',
  'partners.privaDescription': 'Provider of smart greenhouse environment control systems',
  'partners.netafimSpecialization': 'Drip irrigation systems',
  'partners.netafimDescription': 'Global leader in smart irrigation technology',
  'partners.philipsSpecialization': 'LED lighting systems',
  'partners.philipsDescription': 'Manufacturer of LED grow lights for greenhouses',
  'partners.ridderSpecialization': 'Greenhouse automation',
  'partners.ridderDescription': 'Automation and smart control systems',
  'partners.iranGlassCompany': 'Iran Glass Company',
  'partners.iranGlassSpecialization': 'Specialized glass production',
  'partners.iranGlassDescription': 'Supplier of durable and quality glass for greenhouses',
  'partners.mobarakehSteel': 'Mobarakeh Steel',
  'partners.mobarakehSteelSpecialization': 'Steel structure production',
  'partners.mobarakehSteelDescription': 'Supplier of steel and durable greenhouse structures',
  'partners.tabrizPetrochemical': 'Tabriz Petrochemical',
  'partners.tabrizPetrochemicalSpecialization': 'Polymer and plastic materials',
  'partners.tabrizPetrochemicalDescription': 'Manufacturer of durable plastic materials for greenhouse covering',
  'partners.isfahanArea': '5,000 sqm',
  'partners.isfahanPartner': 'Van der Hoeven + Chehelsotoon',
  'partners.mashadArea': '8,000 sqm',
  'partners.mashadPartner': 'Van der Hoeven + Domestic Partners',
  'partners.ardabilArea': '3,000 sqm',
  'partners.ardabilPartner': 'Multilateral Cooperation',
  
  // News page
  'news.title': 'Latest News & Information',
  'news.subtitle': 'Stay updated with the latest developments in greenhouse technology',
  'news.heroTitle': 'Latest News & Information',
  'news.heroSubtitle': 'Latest news, technologies and innovations in the world of greenhouse and modern agriculture',
  'news.featured': 'Featured News',
  'news.recent': 'Other News',
  'news.categories': 'Categories',
  'news.searchPlaceholder': 'Search in news, articles and tags...',
  'news.project': 'Project',
  'news.technology': 'Technology',
  'news.product': 'Products',
  'news.international': 'International',
  'news.tips': 'Technical Tips',
  'news.research': 'Research',
  'news.events': 'Events',
  'news.all': 'All',
  'news.readMore': 'Read More',
  'news.readTime': 'min',
  'news.date': 'Date',
  'news.category': 'Category',
  'news.tags': 'Tags',
  'news.noResults': 'No results found',
  'news.noResultsDesc': 'Please try different keywords',
  'news.articlesFound': 'articles found',
  'news.newsletter': 'Newsletter Subscription',
  'news.newsletterTitle': 'Newsletter Subscription',
  'news.newsletterDesc': 'Receive the latest news and specialized articles on greenhouse technology directly in your email',
  'news.emailPlaceholder': 'Your email address',
  'news.subscribe': 'Subscribe',
  
  // News categories
  'news.cat.all': 'All',
  'news.cat.project': 'Project',
  'news.cat.products': 'Products',
  'news.cat.technology': 'Technology',
  'news.cat.international': 'International',
  'news.cat.tips': 'Technical Tips',
  'news.cat.research': 'Research',
  'news.cat.events': 'Events',
  
  // Contact page (modified)
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Get in touch with Iran GH experts and receive free consultation',
  'contact.phone': 'Phone Contact',
  'contact.phoneDesc': 'Call us for immediate consultation',
  'contact.email': 'Email',
  'contact.emailDesc': 'Send us your messages',
  'contact.address': 'Office Address',
  'contact.addressDesc': 'Visit us at the address below for in-person meetings',
  'contact.fullAddress': 'Tehran, Motahari St., Yousefian St., Shokooh Alley, No. 6',
  'contact.warehouses': 'Warehouses',
  'contact.warehousesDesc': 'Our warehouse locations',
  'contact.warehouse1': 'Jajrood Warehouse',
  'contact.warehouse2': 'Shoosh Tehran Warehouse',
  'contact.formTitle': 'Contact Form',
  'contact.formDesc': 'Fill out the form below so our experts can contact you as soon as possible',
  'contact.name': 'Full Name',
  'contact.namePlaceholder': 'Enter your full name',
  'contact.email': 'Email',
  'contact.emailPlaceholder': 'Enter your email address',
  'contact.phoneNumber': 'Phone Number',
  'contact.phonePlaceholder': 'Enter your phone number',
  'contact.projectType': 'Project Type',
  'contact.selectProjectType': 'Select project type',
  'contact.commercial': 'Commercial',
  'contact.research': 'Research',
  'contact.hydroponic': 'Hydroponic',
  'contact.traditional': 'Traditional',
  'contact.consultation': 'Consultation',
  'contact.budget': 'Approximate Budget',
  'contact.selectBudget': 'Select approximate budget',
  'contact.under100k': 'Under $100,000',
  'contact.budget100k500k': '$100,000 - $500,000',
  'contact.budget500k1m': '$500,000 - $1,000,000',
  'contact.over1m': 'Over $1,000,000',
  'contact.timeline': 'Project Timeline',
  'contact.selectTimeline': 'Select desired timeline',
  'contact.immediate': 'Immediate',
  'contact.timeline1to3': '1-3 months',
  'contact.timeline3to6': '3-6 months',
  'contact.timeline6plus': 'More than 6 months',
  'contact.subject': 'Subject',
  'contact.subjectPlaceholder': 'Enter your message subject',
  'contact.message': 'Message',
  'contact.messagePlaceholder': 'Write complete details of your project and requirements...',
  'contact.characters': 'characters',
  'contact.sendMessage': 'Send Message',
  'contact.sending': 'Sending...',
  'contact.successMessage': 'Your message has been sent successfully. Our experts will contact you as soon as possible.',
  'contact.errorMessage': 'Error sending message. Please try again.',
  'contact.location': 'Location',
  'contact.officeHours': 'Office Hours',
  'contact.saturday': 'Saturday',
  'contact.saturdayHours': '8:00 AM - 5:00 PM',
  'contact.sunday': 'Sunday',
  'contact.sundayHours': '8:00 AM - 5:00 PM',
  'contact.monday': 'Monday',
  'contact.mondayHours': '8:00 AM - 5:00 PM',
  'contact.tuesday': 'Tuesday',
  'contact.tuesdayHours': '8:00 AM - 5:00 PM',
  'contact.wednesday': 'Wednesday',
  'contact.wednesdayHours': '8:00 AM - 5:00 PM',
  'contact.thursday': 'Thursday',
  'contact.thursdayHours': '8:00 AM - 5:00 PM',
  'contact.friday': 'Friday',
  'contact.fridayHours': 'Closed',
  'contact.emergencySupport': 'Emergency Support',
  'contact.emergencySupportDesc': 'For urgent greenhouse issues outside office hours',
  'contact.faq': 'Frequently Asked Questions',
  'contact.faqDesc': 'Answers to common questions about contact and services',
  'contact.faq.q1': 'How can I get free consultation?',
  'contact.faq.a1': 'You can request free consultation through phone call, email, or by filling out the contact form. Our experts will contact you as soon as possible.',
  'contact.faq.q2': 'What is the response time for messages?',
  'contact.faq.a2': 'We usually respond to your messages within 24 hours. For urgent matters, it\'s better to make a phone call.',
  'contact.faq.q3': 'Is it possible to visit the project site?',
  'contact.faq.a3': 'Yes, our experts visit the project site for more detailed assessment and specialized consultation.',
  'contact.faq.q4': 'What is the cost of consultation and site visit?',
  'contact.faq.a4': 'Initial consultation and site visit for serious projects are completely free. Only if cooperation doesn\'t continue, site visit costs will be charged.',
  'contact.faq.q5': 'Do you have 24-hour support?',
  'contact.faq.a5': 'We provide 24-hour support for current customers and emergency greenhouse issues. For other matters, we respond during office hours.',
  
  // Product detail page
  'product.specifications': 'Technical Specifications',
  'product.applications': 'Applications',
  'product.installationGuide': 'Installation Guide',
  'product.relatedProducts': 'Related Products',
  'product.features': 'Features',
  'product.benefits': 'Benefits',
  'product.technicalSpecs': 'Technical Specifications',
  'product.usage': 'Usage',
  'product.maintenance': 'Maintenance',
  'product.warranty': 'Warranty',
  'product.availability': 'Availability',
  'product.inStock': 'In Stock',
  'product.outOfStock': 'Out of Stock',
  'product.limitedStock': 'Limited Stock',
  'product.orderNow': 'Order Now',
  'product.addToCart': 'Add to Cart',
  'product.requestQuote': 'Request Quote',
  'product.downloadCatalog': 'Download Catalog',
  'product.shareProduct': 'Share Product',
  'product.printPage': 'Print Page',
  'product.backToProducts': 'Back to Products',
  
  // UV Thread specific translations
  'product.uvThread.title': 'UV Greenhouse Thread',
  'product.uvThread.subtitle': 'Twisted polypropylene thread with UV protection for greenhouses',
  'product.uvThread.description': 'UV Greenhouse Thread is a specialized product for supporting and guiding plants in modern greenhouses. This thread with polypropylene material and 4% UV protection has high resistance against sunlight and environmental conditions.',
  'product.uvThread.specs.length': 'Length per roll',
  'product.uvThread.specs.weight': 'Weight per roll',
  'product.uvThread.specs.material': 'Material',
  'product.uvThread.specs.uvProtection': 'UV Protection',
  'product.uvThread.specs.type': 'Thread Type',
  'product.uvThread.specs.colors': 'Available Colors',
  'product.uvThread.specs.manufacturer': 'Manufacturer',
  'product.uvThread.specs.lengthValue': '2000 meters',
  'product.uvThread.specs.weightValue': '2 kilograms',
  'product.uvThread.specs.materialValue': 'Polypropylene (PP)',
  'product.uvThread.specs.uvProtectionValue': '4%',
  'product.uvThread.specs.typeValue': 'Twisted thread',
  'product.uvThread.specs.colorsValue': 'White, Green',
  'product.uvThread.specs.manufacturerValue': 'Iran GH',
  'product.uvThread.applications.title': 'UV Greenhouse Thread Applications',
  'product.uvThread.applications.tomato': 'Tomato Support',
  'product.uvThread.applications.tomatoDesc': 'Guiding and supporting tomato stems in vertical growth',
  'product.uvThread.applications.cucumber': 'Cucumber Support',
  'product.uvThread.applications.cucumberDesc': 'Supporting cucumber growth and preventing stem breakage',
  'product.uvThread.applications.beans': 'Bean Support',
  'product.uvThread.applications.beansDesc': 'Guiding climbing bean growth and supporting fruits',
  'product.uvThread.applications.pepper': 'Pepper Support',
  'product.uvThread.applications.pepperDesc': 'Supporting pepper branches and preventing bending',
  'product.uvThread.applications.herbs': 'Medicinal Plants',
  'product.uvThread.applications.herbsDesc': 'Supporting and guiding climbing medicinal plants',
  'product.uvThread.applications.flowers': 'Ornamental Flowers',
  'product.uvThread.applications.flowersDesc': 'Supporting tall and delicate flower stems',
  'product.uvThread.installation.title': 'Installation and Usage Guide',
  'product.uvThread.installation.step1': 'Preparation',
  'product.uvThread.installation.step1Desc': 'First clean the installation area and prepare necessary tools',
  'product.uvThread.installation.step2': 'Install Connection Points',
  'product.uvThread.installation.step2Desc': 'Install top and bottom connection points at appropriate distance',
  'product.uvThread.installation.step3': 'String the Thread',
  'product.uvThread.installation.step3Desc': 'Pull the thread from bottom to top and tie with appropriate tension',
  'product.uvThread.installation.step4': 'Tie the Plant',
  'product.uvThread.installation.step4Desc': 'Tie the plant to the thread with soft loops to avoid damage',
  'product.uvThread.installation.step5': 'Periodic Check',
  'product.uvThread.installation.step5Desc': 'Regularly check the condition of thread and connections',
  'product.uvThread.features.title': 'Features and Benefits',
  'product.uvThread.features.uvResistant': 'UV Resistant',
  'product.uvThread.features.uvResistantDesc': '4% protection against ultraviolet rays',
  'product.uvThread.features.highStrength': 'High Strength',
  'product.uvThread.features.highStrengthDesc': 'Can support weight up to 15 kilograms',
  'product.uvThread.features.weatherResistant': 'Weather Resistant',
  'product.uvThread.features.weatherResistantDesc': 'Resistant to moisture, rain and temperature changes',
  'product.uvThread.features.easyInstall': 'Easy Installation',
  'product.uvThread.features.easyInstallDesc': 'Quick and easy installation without special tools',
  'product.uvThread.features.longLasting': 'Long Lasting',
  'product.uvThread.features.longLastingDesc': 'Long service life in greenhouse conditions',
  'product.uvThread.features.costEffective': 'Cost Effective',
  'product.uvThread.features.costEffectiveDesc': 'Reasonable price with high quality',
  'product.uvThread.maintenance.title': 'Maintenance and Repairs',
  'product.uvThread.maintenance.cleaning': 'Cleaning',
  'product.uvThread.maintenance.cleaningDesc': 'Clean with water and mild soap if needed',
  'product.uvThread.maintenance.inspection': 'Periodic Inspection',
  'product.uvThread.maintenance.inspectionDesc': 'Check thread and connections condition monthly',
  'product.uvThread.maintenance.replacement': 'Replacement',
  'product.uvThread.maintenance.replacementDesc': 'Replace thread if worn or damaged',
  'product.uvThread.maintenance.storage': 'Storage',
  'product.uvThread.maintenance.storageDesc': 'Store in dry place away from direct sunlight',
  'product.uvThread.related.title': 'Related Products',
  'product.uvThread.related.clips': 'Support Clips',
  'product.uvThread.related.clipsDesc': 'Special clips for connecting thread to plant',
  'product.uvThread.related.hooks': 'Hanging Hooks',
  'product.uvThread.related.hooksDesc': 'Hooks for ceiling installation in greenhouse',
  'product.uvThread.related.tensioners': 'Tension Adjusters',
  'product.uvThread.related.tensionersDesc': 'Tools for adjusting thread tension',
  'product.uvThread.related.supports': 'Support Beams',
  'product.uvThread.related.supportsDesc': 'Metal beams for installing support system',
  
  // About page hero section
  'about.hero.badge': 'Leading in Greenhouse Industry',
  'about.hero.title': 'Aria Green House',
  'about.hero.subtitle': 'Leading provider of smart greenhouse solutions in Iran',
  'about.hero.description': 'With over 15 years of experience in designing, building and equipping modern greenhouses, we help farmers achieve higher productivity using advanced technologies.',
  'about.hero.features.experience': '15 Years Experience',
  'about.hero.features.experience_desc': 'In designing and building modern greenhouses',
  'about.hero.features.international': 'International Cooperation',
  'about.hero.features.international_desc': 'With the most reputable global companies',
  'about.hero.cta.contact': 'Contact Us',
  'about.hero.cta.projects': 'View Projects',
  'about.hero.achievement.title': 'Top Greenhouse Company in Iran',
  'about.hero.achievement.description': 'Recipient of multiple awards in agriculture industry',
  
  // About page stats
  'about.stats.experience': 'Years Experience',
  'about.stats.projects': 'Successful Projects',
  'about.stats.area': 'Sqm Greenhouse',
  'about.stats.customers': 'Satisfied Customers',
  
  // About page story section
  'about.story.title': 'Our Story',
  'about.story.subtitle': 'A journey from idea to progress',
  'about.story.paragraph1': 'Aria Green House was founded in 2009 with the goal of revolutionizing Iran\'s agriculture industry. What started as a small engineering company has today become one of the country\'s leading greenhouse companies.',
  'about.story.paragraph2': 'By combining domestic technical knowledge with advanced international technologies, we have successfully completed over 50 major projects. From small family greenhouses to large commercial complexes, all are within our area of expertise.',
  'about.story.paragraph3': 'Today, we continue on the path of innovation and continuous improvement, and our goal is to help develop sustainable and modern agriculture in Iran and the region.',
  'about.story.image_alt': 'Aria Green House company history',
  
  // About page mission, vision, values
  'about.mission.title': 'Our Mission',
  'about.mission.description': 'Providing innovative and sustainable solutions to increase agricultural productivity and preserve natural resources through designing and building smart greenhouses with international standards.',
  'about.vision.title': 'Our Vision',
  'about.vision.description': 'Becoming the leading and most reputable greenhouse company in the Middle East region and helping to ensure food security through developing modern and sustainable agriculture.',
  'about.values.title': 'Our Values',
  'about.values.description': 'Innovation, quality, sustainability, honesty, customer commitment and social responsibility are the fundamental principles of our activities in all projects and services.',
  'about.values.section_title': 'Our Core Values',
  'about.values.section_description': 'Principles that guide all our activities',
  'about.values.innovation.title': 'Innovation',
  'about.values.innovation.description': 'Always seeking new and better solutions for agricultural challenges',
  'about.values.quality.title': 'Quality',
  'about.values.quality.description': 'Using the best materials and equipment with international standards',
  'about.values.service.title': 'Superior Service',
  'about.values.service.description': 'Providing comprehensive services from design to after-sales support',
  'about.values.sustainability.title': 'Sustainability',
  'about.values.sustainability.description': 'Commitment to environmental protection and optimal use of natural resources',
  
  // About page team section
  'about.team.title': 'Our Expert Team',
  'about.team.description': 'Consisting of the best engineers and specialists in the greenhouse industry',
  'about.team.ceo.name': 'Engineer Ahmad Rezaei',
  'about.team.ceo.position': 'CEO and Founder',
  'about.team.ceo.description': 'With over 20 years of experience in agriculture industry and managing large greenhouse projects',
  'about.team.engineer.name': 'Engineer Fatemeh Ahmadi',
  'about.team.engineer.position': 'Technical and Design Manager',
  'about.team.engineer.description': 'Specialist in smart greenhouse design and climate control systems',
  'about.team.consultant.name': 'Dr. Ali Mohammadi',
  'about.team.consultant.position': 'Senior Agricultural Consultant',
  'about.team.consultant.description': 'PhD in Agriculture and specialist in hydroponic systems and soilless cultivation',
  
  // About page CTA section
  'about.cta.title': 'Ready to Work With Us?',
  'about.cta.description': 'Let\'s discuss how we can help you achieve our greenhouse goals',
  'about.cta.contact': 'Contact Us',
  'about.cta.services': 'View Services'
};

export default enCommon;
